import { render, staticRenderFns } from "./FeatureTable.vue?vue&type=template&id=526f4d75&scoped=true"
import script from "./FeatureTable.vue?vue&type=script&lang=js"
export * from "./FeatureTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureTable.vue?vue&type=style&index=0&id=526f4d75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f4d75",
  null
  
)

export default component.exports